import { isValidAutomergeUrl, parseAutomergeUrl, stringifyAutomergeUrl, } from "@automerge/automerge-repo";
/** Creates a new document initialized with the given datatype using create2 */
export const createDocOfDatatype2 = async (datatype, repo, change) => {
    const handle = await repo.create2();
    handle.change((doc) => {
        datatype.module.init(doc, repo);
        let importUrl = datatype.importUrl;
        if (isValidAutomergeUrl(importUrl)) {
            const parsed = parseAutomergeUrl(importUrl);
            if (parsed.heads) {
                console.warn(`stripping heads from importUrl for ${datatype.id} for new document`);
            }
            importUrl = stringifyAutomergeUrl(parsed.documentId);
        }
        doc["@patchwork"] = {
            type: datatype.id,
            suggestedImportUrl: importUrl,
        };
        if (change) {
            change(doc);
        }
    });
    return handle;
};
